import { Controller } from '@hotwired/stimulus'

// Shows or hides elements based on the value of a source input (text, checkbox, radio).
//
// Targets:
//   source  — the input/checkbox/radio that drives visibility
//   content — the element(s) to show or hide
//
// Values:
//   expected (String, optional) — the source value that makes content visible.
//                                 Omit to show whenever any source has a value or is checked.
//   hiddenClass (String, default: 'display-none') — CSS class toggled on hidden content.
//
// Usage:
//   data-controller="conditional-visibility"
//   data-conditional-visibility-expected-value="rejected"   ← show only when "rejected" is selected
//   data-action="change->conditional-visibility#refresh"    ← on the source element(s)
export default class extends Controller {
  static targets = ['source', 'content']
  static values = {
    expected: String,
    hiddenClass: { type: String, default: 'display-none' }
  }

  connect() {
    this.refresh()
  }

  refresh() {
    const visible = this.matchesExpectedValue()

    this.contentTargets.forEach((content) => {
      content.classList.toggle(this.hiddenClassValue, !visible)
      content.setAttribute('aria-hidden', String(!visible))
    })
  }

  matchesExpectedValue() {
    if (this.sourceTargets.length > 1) {
      if (this.hasExpectedValue) {
        return this.sourceTargets.some((source) => source.checked && source.value === this.expectedValue)
      }

      return this.sourceTargets.some((source) => source.checked)
    }

    const source = this.sourceTarget

    if (source.type === 'checkbox') {
      if (!this.hasExpectedValue) return source.checked

      return source.checked === (this.expectedValue === 'true')
    }

    if (!this.hasExpectedValue) return source.value.length > 0

    return source.value === this.expectedValue
  }
}
